var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 205,
    viewBox: "0 0 478 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 478,
    height: 205,
    fill: "#F1F1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1533_22774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.007 86.125C212.007 84.3348 212.718 82.6179 213.984 81.352C215.25 80.0862 216.967 79.375 218.757 79.375H259.257C261.047 79.375 262.764 80.0862 264.03 81.352C265.296 82.6179 266.007 84.3348 266.007 86.125V119.875C266.007 121.665 265.296 123.382 264.03 124.648C262.764 125.914 261.047 126.625 259.257 126.625H218.757C216.967 126.625 215.25 125.914 213.984 124.648C212.718 123.382 212.007 121.665 212.007 119.875V86.125ZM215.382 116.5V119.875C215.382 120.77 215.737 121.629 216.37 122.261C217.003 122.894 217.862 123.25 218.757 123.25H259.257C260.152 123.25 261.01 122.894 261.643 122.261C262.276 121.629 262.632 120.77 262.632 119.875V108.062L249.884 101.491C249.568 101.333 249.21 101.278 248.86 101.334C248.511 101.39 248.188 101.555 247.937 101.805L235.416 114.326L226.438 108.346C226.114 108.13 225.725 108.033 225.338 108.071C224.95 108.109 224.588 108.28 224.312 108.555L215.382 116.5ZM232.257 94.5625C232.257 93.2198 231.723 91.9322 230.774 90.9828C229.825 90.0334 228.537 89.5 227.194 89.5C225.852 89.5 224.564 90.0334 223.615 90.9828C222.665 91.9322 222.132 93.2198 222.132 94.5625C222.132 95.9052 222.665 97.1928 223.615 98.1422C224.564 99.0916 225.852 99.625 227.194 99.625C228.537 99.625 229.825 99.0916 230.774 98.1422C231.723 97.1928 232.257 95.9052 232.257 94.5625Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1533_22774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(212 76)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.ad1e1a463b658b0b15663a4bd2c121ab.svg";
export { ForwardRef as ReactComponent };